// extracted by mini-css-extract-plugin
export default {"SignContextButton":"SignContextMenu_SignContextButton__PFw7s","DeleteContextButton":"SignContextMenu_DeleteContextButton__c+Xzx"};